import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { useApi } from "@/lib/api";
import { Pick, Row } from "./parts";
import ServerTools from "./ServerTools";

const SCOPES = [["main", "Home e pagine del menu (max 6)"], ["full", "Tutte le pagine"]];

function ToolStatus() {
  const api = useApi();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/visual-review/status").then(({ data }) => setS(data)).catch(() => setS(false)); }, [api]);
  if (!s) return null;
  return (
    <p className={`flex items-center gap-1.5 text-xs ${s.ok ? "text-emerald-700" : "text-amber-800"}`} data-testid="settings-review-tools">
      {s.ok ? <CheckCircle2 size={13} /> : <AlertTriangle size={13} />}{s.message}
    </p>
  );
}

export default function VisualReviewSettings({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <>
      <Row label="Tetto di spesa per revisione" hint="USD stimati, analisi + correzioni">
        <Input type="number" min="0.5" step="0.5" value={value.max_usd} onChange={(e) => set("max_usd", e.target.value)} className="max-w-[160px]" data-testid="settings-review-max-input" />
      </Row>
      <Row label="Pagine da controllare"><Pick value={value.scope} onChange={(v) => set("scope", v)} options={SCOPES} testid="settings-review-scope-select" /></Row>
      <Row label="A fine generazione" hint="Solo screenshot gratuiti">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <Switch checked={value.auto_after_generation} onCheckedChange={(v) => set("auto_after_generation", v)} data-testid="settings-review-auto-switch" />
          Prepara gli screenshot e proponi la revisione
        </label>
      </Row>
      <ToolStatus />
      <ServerTools />
    </>
  );
}
